import { render, staticRenderFns } from "./warn-settings-form.vue?vue&type=template&id=4da59c14&scoped=true&"
import script from "./warn-settings-form.vue?vue&type=script&lang=js&"
export * from "./warn-settings-form.vue?vue&type=script&lang=js&"
import style0 from "./warn-settings-form.vue?vue&type=style&index=0&id=4da59c14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da59c14",
  null
  
)

export default component.exports